import { Avatar, Dialog } from '@mui/material';
import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import LogIn from '../LogIn/LogIn';
import AuthContext from '../../../context/auth-context';

const ChefControl = () => {
  const authContext = useContext(AuthContext);

  if (authContext.loggedUser === null) {
    return ReactDOM.createPortal(
      <Dialog open={true} maxWidth="xs" fullWidth>
        <LogIn />
      </Dialog>,
      document.getElementById('primary')
    );
  }

  // use account menu https://mui.com/components/menus/#account-menu

  return (
    <Avatar
      className="profile-avatar"
      alt={authContext.loggedUser.name}
      src={authContext.loggedUser.picture || undefined}
      sx={{ width: 50, height: 50 }}
    >
      {!authContext.loggedUser.picture && authContext.loggedUser.name
        ? authContext.loggedUser.name.charAt(0).toUpperCase()
        : null}
    </Avatar>
  );
};

export default ChefControl;
